export enum ThemeType {
  BLUE = 1,
  GREEN = 2,
  ORANGE = 3,
  PINK = 4,
  NEUTRAL = 5,
}

export interface ThemeConfig {
  type: ThemeType
  primaryColor: string
  backgroundColor: string
  backgroundImage: string
  surfaceColor: string
  surfaceBorderColor: string
  surfaceMutedColor: string
  accentTextColor: string
  surfaceEmphasisColor: string
  warningColor: string
}

export const themeConfigs: Record<ThemeType, ThemeConfig> = {
  [ThemeType.BLUE]: {
    type: ThemeType.BLUE,
    primaryColor: '#1e3a8a',
    backgroundColor: '#f0f5ff',
    surfaceColor: '#ffffff',
    surfaceBorderColor: '#d6dff5',
    surfaceMutedColor: '#eef2ff',
    accentTextColor: '#1e3a8a',
    surfaceEmphasisColor: '#e3e9fa',
    warningColor: '#b91c1c',
    backgroundImage: './query_bg.png',
  },
  [ThemeType.GREEN]: {
    type: ThemeType.GREEN,
    primaryColor: '#047857',
    backgroundColor: '#f1fcf6',
    surfaceColor: '#ffffff',
    surfaceBorderColor: '#c9f0df',
    surfaceMutedColor: '#dff7ed',
    accentTextColor: '#0f766e',
    surfaceEmphasisColor: '#d1f3e4',
    warningColor: '#b91c1c',
    backgroundImage: './query_bg_green.png',
  },
  [ThemeType.ORANGE]: {
    type: ThemeType.ORANGE,
    primaryColor: '#b45309',
    backgroundColor: '#fef7ed',
    surfaceColor: '#ffffff',
    surfaceBorderColor: '#eadcc5',
    surfaceMutedColor: '#fef1dd',
    accentTextColor: '#b45309',
    surfaceEmphasisColor: '#fde4c3',
    warningColor: '#b91c1c',
    backgroundImage: './query_bg_orange.png',
  },
  [ThemeType.PINK]: {
    type: ThemeType.PINK,
    primaryColor: '#DB2777',
    backgroundColor: '#fdf2f8',
    surfaceColor: '#ffffff',
    surfaceBorderColor: '#f9c9e3',
    surfaceMutedColor: '#fde1f0',
    accentTextColor: '#be185d',
    surfaceEmphasisColor: '#fbd6eb',
    warningColor: '#b91c1c',
    backgroundImage: './query_bg_pink.png',
  },
  [ThemeType.NEUTRAL]: {
    type: ThemeType.NEUTRAL,
    primaryColor: '#1F2937',
    backgroundColor: '#FFFFFF',
    surfaceColor: '#FFFFFF',
    surfaceBorderColor: '#D1D5DB',
    surfaceMutedColor: '#F3F4F6',
    accentTextColor: '#374151',
    surfaceEmphasisColor: '#E5E7EB',
    warningColor: '#DC2626',
    backgroundImage: 'none',
  },
}

export const getThemeConfig = (themeType?: number): ThemeConfig => {
  const theme = themeType as ThemeType
  return themeConfigs[theme] || themeConfigs[ThemeType.BLUE]
}

export const getThemeSecondaryColor = (themeType?: number): string => {
  const theme = themeType as ThemeType
  const secondaryColors = {
    [ThemeType.BLUE]: '#60A5FA',
    [ThemeType.GREEN]: '#34D399',
    [ThemeType.ORANGE]: '#FB923C',
    [ThemeType.PINK]: '#F472B6',
    [ThemeType.NEUTRAL]: '#6B7280',
  }
  return secondaryColors[theme] || secondaryColors[ThemeType.BLUE]
}
